import { render, staticRenderFns } from "./frame-title-text.vue?vue&type=template&id=7d4cb622&scoped=true"
import script from "./frame-title-text.vue?vue&type=script&lang=js"
export * from "./frame-title-text.vue?vue&type=script&lang=js"
import style0 from "./frame-title-text.vue?vue&type=style&index=0&id=7d4cb622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4cb622",
  null
  
)

export default component.exports